export const UnavailableSlotMessageDataHooks = {
  NOTIFICATION_MESSAGE: 'unavailable-slot-notification-message',
};
